import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=cb4a7fbe&scoped=true&"
import script from "./WelcomeCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeCard.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=cb4a7fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a7fbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VFlex,VIcon,VLayout})
